/*
* Helper js provides set of function that are used for parsing data
* @usage import {function-name} from 'helper.js'
*/
const alertify = require('alertifyjs');

export const onServerError = (messages, callBack) => {
  let header = "<span style='color:red'>"+JSON.parse(localStorage.getItem("langVars"))['error']+"</span>";
  switch (typeof messages) {
    case 'string':
      alertify.alert(header, messages);
      break;

    case 'object':
      let list = '<ul>';
      messages.map(error => {
        list += '<li>' + error + '</li>';
      });
      list += '</ul>';
      alertify.alert(header, list);
      break;

    default:
      alertify.alert(header, JSON.parse(localStorage.getItem("langVars"))['somethingWentWrong']);
      break;
  }
  return false;
};

export const Required = string => {
  if (
    typeof string === 'undefined' ||
    string === 'null' ||
    string === null ||
    (typeof string !== 'undefined' && string.length === 0) ||
    !string.trim()
  ) {
    return false;
  } else {
    return true;
  }
};

export const Mobile = mobileNumber => {
  let phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (mobileNumber && mobileNumber.match(phoneno)) {
    return true;
  } else {
    return false;
  }
};

export const Email = email => {
  let emailPatter = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailPatter.test(email)) {
    return true;
  }
  return false;
};

export const testRegex = (pattern, string) => {
  const regexObject = new RegExp(pattern);
  return regexObject.test(string);
};

export const checkForEmptyString = string => {
  let testString = string || '';
  return testString.replace(/\s/g, '').length > 0;
};

export const allowOnlySpaces = string => {
  const regex = new RegExp(/^[a-zA-Z0-9\s]*$/);
  return regex.test(string);
};

export const validateAddress = string => {
  const regex = new RegExp(/^[a-zA-Z0-9\s,'-@!&^$#\/\\_)(]*$/);
  return regex.test(string);
};

export const checkLength = (string, minimumLength) => {
  const testString = string || '';
  return testString.replace(/\s/g, '').length > minimumLength;
};

export const validateAddressInputs = (
  userInput,
  type,
  checkWhenGiven = false
) => {
  switch (type) {
    case 'type-1':
    case 'apartmentOrBuildingDetails':
      return validateAddress(userInput);
    case 'type-2':
    case 'streetAddress':
      return checkWhenGiven === true
        ? validateAddress(userInput)
        : checkForEmptyString(userInput) &&
            validateAddress(userInput) &&
            checkLength(userInput, 3);
    case 'type-3':
    case 'addressName':
    case 'city':
    case 'state':
    case 'zipCode':
      return checkWhenGiven === true
        ? allowOnlySpaces(userInput)
        : checkForEmptyString(userInput) &&
            allowOnlySpaces(userInput) &&
            checkLength(userInput, 3);
    default:
      return true;
  }
};

export const checkNumber = number => {
  const numberPattern = new RegExp(/^[0-9_]+$/);
  return numberPattern.test(number);
};



// WEBPACK FOOTER //
// ./src/lib/validator.js